import { Descriptions } from "antd";
import React from "react";
import svg62 from "../../assets/svg/svg62.svg";
import svg63 from "../../assets/svg/svg63.svg";
import { useSelector } from "react-redux";
import CountUp from "react-countup";

function TotalEmployees() {
  const { personnelSummary } = useSelector((state) => state.dropdown);
  const items = [
    {
      key: "1",
      label: "150",
      children: "Fulltime Employee",
    },
    {
      key: "2",
      label: "50",
      children: "Freelance Employee",
    },
  ];

  return (
    <>
      <div className="product_request_title mb-2">
        Totals Employees <CountUp end={personnelSummary?.total} duration={5} />
      </div>
      <div className="grid grid-cols-2 bg-[#F0F8F7] p-2">
        <div className="flex items-center gap-x-3">
          <CountUp end={personnelSummary?.male} duration={5} />
          <span className="  flex items-center text-[#64ABA1]">
            <img src={svg62} alt="svg62" />
            50
          </span>
        </div>
        <div>Male Employees</div>
      </div>

      <div className="grid grid-cols-2 bg-[#FEF7F6] p-2 mt-[10px]">
        <div className="flex items-center gap-x-3">
          <CountUp end={personnelSummary?.female} duration={5} />
          <span className="  flex items-center text-[#E83310]">
            <img src={svg63} alt="svg63" />
            10
          </span>
        </div>
        <div>Female Employees</div>
      </div>
    </>
  );
}

export default TotalEmployees;
